import React from 'react';
import UserImg from '../../../images/defaultImg.png'
const ProductList2 = ({ Data }) => {
  return (
    <div className="card h-100 mb-0">
      <div className="card-body">
        <h6 className="dash-sub-head">Candidate List</h6>
        <div className='table-responsive mt-2 analytics-div table-overflow'>
          <table className='table table-striped'>
            <thead>
              <tr>
                <th style={{ width: '35%', minWidth: '200px' }}>Candidate</th>
                <th style={{ width: '20%', minWidth: '150px' }}>Email</th>
                <th style={{ width: '15%', minWidth: '150px' }}>Mobile</th>
                <th style={{ width: '15%', minWidth: '100px' }}>Category</th>
              </tr>
            </thead>
            <tbody>
              {Data.length > 0 ? (
                Data.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <img src={UserImg} width={20} height={20} className='imgfluid rounded me-2' alt="User" />
                      {item.full_name}
                    </td>
                    <td>{item.email_id}</td>
                    <td>{item.mobile_no}</td>
                    <td>
                      <div className='status-bar status-green'>{item.category_type}</div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default ProductList2;
